import { createForumAuthBaseQuery, initSharedForum } from '@bpreven/shared';
import { getCookie } from '../../utils/token';
import { baseQueryWithReauth } from '../api/base-query';

export const { forumApi, forumReducer } = initSharedForum({
  baseQuery: createForumAuthBaseQuery({
    baseQueryWithReauth,
    getAccessToken: (getState: () => unknown) => {
      const state = getState() as {
        user?: { accessToken?: string | null };
      };
      const token = getCookie('accessToken') || state.user?.accessToken;
      return token && token.length > 0 ? token : undefined;
    },
  }),
});
